import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Brigitte is a brilliant leader in the data governance space. Her biggest strength is her ability to translate the murky waters of data governance into clear markers that clarify priorities and articulate a clear roadmap for success.',
  author: 'Peter Nichol',
  role: 'Strategic Business Relationship Manager',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8NSdQ4mLUnsvej8S3ShZmA/pasted-image.jpg'
}, {
  quote: 'Brigitte is an exceptional advisor and an asset to any organization seeking to enhance its data management and governance capabilities. Her contributions have been a key factor in our success, and I wholeheartedly recommend her services.',
  author: 'Alex Rothberg',
  role: 'Senior Integration Manager at Laticrete',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mB6fLqksgg5ijcouP469FT/pasted-image.jpg'
}];
export function TestimonialSection() {
  return <section className="bg-black py-24" data-id="element-142">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-143">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-medium text-white mb-4" data-id="element-145">
            What Our Clients Say
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-146">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-gradient-to-br from-purple-500/10 to-cyan-500/10 border border-white/10 rounded-3xl p-8 lg:p-12" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} whileHover={{
          scale: 1.02
        }} data-id="element-147">
              <Quote className="w-10 h-10 text-purple-400 mb-6" data-id="element-148" />
              <blockquote className="text-lg md:text-xl text-white font-medium leading-relaxed mb-8" data-id="element-149">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-4" data-id="element-150">
                <img src={testimonial.image} alt={testimonial.author} className="w-14 h-14 rounded-full object-cover" data-id="element-151" />
                <div data-id="element-152">
                  <p className="text-white font-semibold" data-id="element-153">
                    {testimonial.author}
                  </p>
                  <p className="text-white/60" data-id="element-154">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}